export const FETCH_DATA = "FETCH_DATA";
export const FETCH_CLOUD_DATA = "FETCH_CLOUD_DATA";
export const UPDATE_TEST_ATTENDEE = "UPDATE_TEST_ATTENDEE";
